import { render, staticRenderFns } from "./VerifyFail.vue?vue&type=template&id=1610b4d6&scoped=true"
import script from "./VerifyFail.vue?vue&type=script&lang=js"
export * from "./VerifyFail.vue?vue&type=script&lang=js"
import style0 from "./VerifyFail.vue?vue&type=style&index=0&id=1610b4d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610b4d6",
  null
  
)

export default component.exports